module.exports = __webpack_public_path__ + "static/img/proimg0e0cf49.png";